import "GesagtGetan.Basic/Resources/Private/Assets/Variables/createNamespace";
import { domReady } from "GesagtGetan.Basic/Resources/Private/Assets/Helper";

import "../Fusion/Component/Header";
import "../Fusion/Component/Hamburger";
import "../Fusion/Component/MouseScroller";
import "../Fusion/ContentElements/ImageFixed";
import "../Fusion/News/Entry";
import "../Fusion/Component/Form";

domReady(function() {
    _gg.onReadyRun();
});
